import * as React from 'react';
import allytm from '@ally/allytm';
import { muiErrorFill, muiInfoFill } from '@ally/metronome-icons';
import { Box, Icon, TextBody } from '@ally/metronome-ui';
import { ErrorBanner } from '../../../ErrorBanner';
import log from '../../../../whisper';
import { stringifyError } from '../../../../Utils';
var EnrollCreditCardSuccessBanner = function (_a) {
    var error = _a.error;
    var errorMessage = 'We went ahead and added your credit card to your Snapshot — just log in as usual to manage it. If you don’t see your card, it should show up within 24 hours.';
    React.useEffect(function () {
        allytm.event('customError', errorMessage, stringifyError(error));
    }, []);
    return (React.createElement(Box, { display: "flex", alignItems: "center", mb: "md", "data-allytm-error": errorMessage },
        React.createElement(Box, { flexShrink: 0 },
            React.createElement(Icon, { icon: muiInfoFill, fill: "plum", mr: "xs", size: "lg" })),
        React.createElement(TextBody, { size: "sm", tag: "p", focusOnMount: true }, errorMessage)));
};
export var EnrollCreditCardFailureBanner = function (_a) {
    var error = _a.error;
    var errorMessage = 'We need a little more time on our end — come back in 24 hours and choose Create a profile to set up online access for your card.';
    React.useEffect(function () {
        allytm.event('customError', errorMessage, stringifyError(error));
    }, []);
    return (React.createElement(Box, { display: "flex", alignItems: "center", mb: "md", "data-allytm-error": errorMessage },
        React.createElement(Box, { flexShrink: 0 },
            React.createElement(Icon, { icon: muiErrorFill, fill: "error", mr: "xs", size: "lg" })),
        React.createElement(TextBody, { size: "sm", tag: "p", focusOnMount: true },
            "We need a little more time on our end \u2014 come back in 24 hours and choose",
            ' ',
            React.createElement(TextBody, { size: "sm", tag: "b", weight: "bold" }, "Create a profile"),
            ' ',
            "to set up online access for your card.")));
};
var LoginErrorBanner = function (_a) {
    var error = _a.error, _b = _a.mb, mb = _b === void 0 ? 'sm' : _b, className = _a.className;
    var errorMessage = "Something's not working. Try again later.";
    // If you return a customErrorComponent it will render instead of the
    // default ErrorBanner. You will be responsible for handling any
    // necessary analytics within the custom component
    var customErrorComponent;
    switch (error) {
        case 'CIAM_E08_07_001':
        case 'CIAM_E08_07_002':
            errorMessage = "Hmm. We're having trouble finding you. Try again.";
            break;
        case 'CIAM_E08_02_006':
            // This is a custom error banner and will handle the analytics call in the component
            customErrorComponent = React.createElement(EnrollCreditCardSuccessBanner, { error: error });
            break;
        case 'CIAM_E08_03_004':
        case 'CIAM_E08_03_003':
            // This is a custom error banner and will handle the analytics call in the component
            customErrorComponent = React.createElement(EnrollCreditCardFailureBanner, { error: error });
            break;
        case 'CIAM_E08_03_005':
            errorMessage =
                'Something went wrong, but we saved your new username and password. Log in later to finish enrolling.';
            break;
        case 'CIAM_E08_03_006':
            errorMessage = 'Something went wrong — try logging in again later.';
            break;
        default:
            if (error) {
                log.error({
                    message: ["Unknown error code returned from transmit: ".concat(error)],
                });
            }
    }
    React.useEffect(function () {
        if (error && !customErrorComponent) {
            allytm.event('customError', errorMessage, stringifyError(error));
        }
    }, []);
    if (!error) {
        return null;
    }
    return (React.createElement(Box, { className: className }, customErrorComponent || (React.createElement(ErrorBanner, { mb: mb }, errorMessage))));
};
export default LoginErrorBanner;
//# sourceMappingURL=LoginErrorBanner.js.map